export default "__VITE_ASSET__DrO9fURC__"